import React from "react";
import { Box, Paper, Grid, Skeleton, useTheme, alpha } from "@mui/material";
import { motion } from "framer-motion";

export const IngredientBuilderSkeleton: React.FC = () => {
  const theme = useTheme();

  const Section = ({ height = 200 }: { height?: number }) => (
    <Grid item xs={12}>
      <Paper
        variant="outlined"
        sx={{
          p: 3,
          bgcolor: "background.default",
          height: height,
        }}
      >
        <Box sx={{ mb: 2 }}>
          <Skeleton width={180} height={32} />
        </Box>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Skeleton height={56} />
          </Grid>
          <Grid item xs={12} md={6}>
            <Skeleton height={56} />
          </Grid>
          <Grid item xs={12}>
            <Skeleton height={height - 140} />
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  );

  return (
    <Box sx={{ maxWidth: 1200, margin: "0 auto", p: { xs: 2, md: 4 } }}>
      {/* Page Header Skeleton */}
      <Box sx={{ mb: 3 }}>
        <Skeleton width={300} height={40} />
        <Box sx={{ mt: 1 }}>
          <Skeleton width={500} height={24} />
        </Box>
        <Box sx={{ mt: 2, display: "flex", gap: 1 }}>
          <Skeleton width={120} height={32} />
          <Skeleton width={120} height={32} />
          <Skeleton width={120} height={32} />
        </Box>
      </Box>

      <Paper
        component={motion.div}
        initial={{ y: 20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.3 }}
        sx={{
          p: 3,
          mt: 3,
          borderRadius: 2,
          bgcolor: "background.paper",
          boxShadow: `0 2px 24px 0 ${alpha(theme.palette.primary.dark, 0.12)}`,
        }}
      >
        <Grid container spacing={3}>
          {/* Basic Information Section */}
          <Section height={280} />

          {/* Batch Management Section */}
          <Section height={400} />

          {/* Stock Management Section */}
          <Section height={320} />

          {/* Allergen Information Section */}
          <Section height={240} />

          {/* Additional Information Section */}
          <Section height={200} />
        </Grid>

        {/* Footer Actions Skeleton */}
        <Box
          sx={{
            mt: 4,
            pt: 3,
            borderTop: 1,
            borderColor: "divider",
            display: "flex",
            justifyContent: "flex-end",
            gap: 2,
          }}
        >
          <Skeleton width={100} height={40} />
          <Skeleton width={160} height={40} />
        </Box>
      </Paper>
    </Box>
  );
};
